var _mask, _g, _mask2, _g2, _mask3, _g3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPill1 = function SvgPill1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "pill-1_svg__a",
    width: 26,
    height: 26,
    x: 3,
    y: 3,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3 3.067h25.419v25.419H3z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pill-1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    fillRule: "evenodd",
    d: "M26.43 14.707 14.64 26.496c-2.653 2.653-6.996 2.653-9.65 0s-2.654-6.997 0-9.65l11.79-11.79c2.652-2.653 6.995-2.653 9.65 0 2.652 2.655 2.652 6.997 0 9.65",
    clipRule: "evenodd"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "pill-1_svg__b",
    width: 19,
    height: 18,
    x: 10,
    y: 3,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.884 3.067H28.42v17.535H10.884z",
    clipRule: "evenodd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pill-1_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF773D",
    fillRule: "evenodd",
    d: "m20.535 20.602 5.894-5.895c2.654-2.654 2.654-6.996 0-9.65s-6.996-2.654-9.65 0l-5.895 5.894z",
    clipRule: "evenodd"
  }))), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "pill-1_svg__c",
    width: 18,
    height: 18,
    x: 15,
    y: 16,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15.301 16.351h17.566v17.566H15.3z",
    clipRule: "evenodd"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#pill-1_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E2E2E2",
    fillRule: "evenodd",
    d: "M32.623 23.089a8.78 8.78 0 0 1-6.494 10.584 8.78 8.78 0 0 1-10.584-6.494 8.78 8.78 0 1 1 17.078-4.09",
    clipRule: "evenodd"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "m29.22 22.566-10.88 2.607.499 2.075 10.879-2.607z",
    clipRule: "evenodd"
  })));
};
export default SvgPill1;